/* eslint-disable import/prefer-default-export,max-len,radix, no-extra-boolean-cast */
import { isEmpty, isNil } from 'ramda';
import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';
import FileDownload from 'js-file-download';

import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

import { loadExcelRequest, loadExcelFail, loadExcelSuccess } from './excelActions';

export const REQUEST = 'OVER_UNDER_TIME_REPORT_REQUEST';
export const SUCCESS = 'OVER_UNDER_TIME_REPORT_SUCCESS';
export const FAIL = 'OVER_UNDER_TIME_REPORT_FAIL';

const loadOverUnderTimeReportSuccess = (data) => ({ type: SUCCESS, data });
const loadOverUnderTimeReportRequest = () => ({ type: REQUEST });
const loadOverUnderTimeReportFail = (error) => ({ type: FAIL, error });

export const loadWorkTimeSummaryData = (query) => (dispatch) => {
  dispatch(loadOverUnderTimeReportRequest());
  return communicate({
    url: 'Reports/WorkTimeSummary',
    getParams: Utils.objects.getQueryStringFromObject(query)
  }).then(({ data }) => {
    if (isNil(data.Data) || isEmpty(data.Data)) {
      toastr.error(I18n.t('NoDataAvailable'));
      dispatch(loadOverUnderTimeReportSuccess([]));
    } else {
      const { Data } = data;
      const { Departments, TotalsByPeriods } = Data;
      if (!Departments || !Departments.length) {
        toastr.warning(I18n.t('NoDataAvailable'));
        dispatch(loadOverUnderTimeReportSuccess({
          ...Data,
          Departments: !!Departments ? Departments : [],
          TotalsByPeriods: !!TotalsByPeriods ? TotalsByPeriods : []
        }));
      } else {
        dispatch(loadOverUnderTimeReportSuccess(Data));
      }
    }
  }).catch((err) => {
    dispatch(loadOverUnderTimeReportFail(err));
    toastrError(err);
  });
};

export const workTimeSummaryExcelExport = (params) => (dispatch) => {
  dispatch(loadExcelRequest());
  return communicate({
    url: 'Reports/WorkTimeSummaryExcelExport',
    method: 'get',
    responseType: 'blob',
    getParams: Utils.objects.getQueryStringFromObject(params)
  })
    .then((response) => {
      const fileName = response.headers['x-suggested-filename'] || 'Raport.xlsx';
      dispatch(loadExcelSuccess());
      FileDownload(response.data, fileName);
    })
    .catch((err) => {
      dispatch(loadExcelFail());
      toastrError(err);
    });
};

export const workTimeSummaryExcelV2Export = (params) => (dispatch) => {
  dispatch(loadExcelRequest());
  return communicate({
    url: 'Reports/WorkTimeSummaryExcelExport-v2',
    method: 'get',
    responseType: 'blob',
    getParams: Utils.objects.getQueryStringFromObject(params)
  })
    .then((response) => {
      const fileName = response.headers['x-suggested-filename'] || 'Raport.xlsx';
      dispatch(loadExcelSuccess());
      FileDownload(response.data, fileName);
    })
    .catch((err) => {
      dispatch(loadExcelFail());
      toastrError(err);
    });
};
